/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { Container } from '@adobe-commerce/elsie/lib';
import { SignUpForm } from '@/auth/components';
import { SignUpProps } from '@/auth/types';

export const SignUp: Container<SignUpProps> = ({
  slots,
  formSize,
  apiVersion2,
  addressesData,
  isAutoSignInEnabled,
  requireRetypePassword,
  inputsDefaultValueSet,
  fieldsConfigForApiVersion1,
  hideCloseBtnOnEmailConfirmation,
  routeRedirectOnEmailConfirmationClose,
  routeRedirectOnSignIn,
  onSuccessCallback,
  onErrorCallback,
  routeSignIn,
}) => {
  return (
    <div className="auth-sign-up">
      <SignUpForm
        requireRetypePassword={requireRetypePassword}
        formSize={formSize}
        apiVersion2={apiVersion2}
        addressesData={addressesData}
        isAutoSignInEnabled={isAutoSignInEnabled}
        inputsDefaultValueSet={inputsDefaultValueSet}
        fieldsConfigForApiVersion1={fieldsConfigForApiVersion1}
        hideCloseBtnOnEmailConfirmation={hideCloseBtnOnEmailConfirmation}
        routeRedirectOnEmailConfirmationClose={
          routeRedirectOnEmailConfirmationClose
        }
        routeRedirectOnSignIn={routeRedirectOnSignIn}
        routeSignIn={routeSignIn}
        slots={slots}
        onErrorCallback={onErrorCallback}
        onSuccessCallback={onSuccessCallback}
      />
    </div>
  );
};
